import { makeStyles } from '@material-ui/core';
import React from 'react';
import CoachingCard from './CoachingCard';

const useStyles = makeStyles((theme) => ({
    containerfluid: {
        backgroundRepeat: "no-repeat",
        width: "100%",
        backgroundSize: "cover",
      },
      container: {
        maxWidth: "1250px",
        margin: "0 auto",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-around",
      },
      
  }));

function CoachingContent({filteredDataByCoachings, selectedExam, selectedCity}) {
  // console.log(">>", filteredDataByCoachings);
    const classes = useStyles();
  return (
    <div className={classes.containerfluid}>
      <div className={classes.container}>
          
        {selectedExam!==-1 ? 
          filteredDataByCoachings?.map((data)=>
            selectedExam === data.exam && ( 
              selectedCity!==-1 ? selectedCity === data.city && ( 
              <CoachingCard key={data.id} cardData={data}/>
              ) : <CoachingCard key={data.id} cardData={data}/>
          ))
          :
          ( selectedCity!==-1 ? 
            filteredDataByCoachings?.map((data)=>
              selectedCity === data.city && ( 
              <CoachingCard key={data.id} cardData={data}/>
            ))
          :
            filteredDataByCoachings?.map((data)=>( 
              <CoachingCard key={data.id} cardData={data}/>
            ))
          )
        }
        
      </div>
    </div>
  )
}

export default CoachingContent;